<template>
    <div id="main" class="is-flex">
        <div class="page mb-0">
            <div class="vertical-flow">
                <!-- TÍTULO E BREADCRUMB -->
                <h1 class="title"> {{ $t('routes') }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a>{{$t('vendas')}}</a></li>
                        <li><a>{{$t('relatorios')}}</a></li>
                        <li><a href="#" aria-current="page">{{ $t('routes') }}</a></li>
                    </ul>
                </nav>

                <!-- ABAS -->
                <ul class="nav nav-tabs">
                    <li
                        v-for="(aba, i) in abas"
                        :class="{'active': abaSelecionada == i}"
                        :key="i"
                        @click="abaSelecionada = i"
                    >
                        <a data-toggle="tab">{{$t(aba)}}</a>
                    </li>
                </ul>

                <mapa
                    v-show="abas[abaSelecionada] == 'mapa'"
                    ref="abaMapa"
                    :rotas="rotas"
                    :data.sync="dataRota"
                    :selected-id.sync="idPinAberto"
                    :first-time="firstTime"
                    @pesquisar="loadData"
                />

                <dados
                    v-show="abas[abaSelecionada] == 'dados'"
                    :rotas="rotas"
                    :first-time="firstTime"
                    :selected-row="idPinAberto"
                />
               
            </div>
        </div><!-- end .page.mb-0 -->
    </div><!-- end #main -->
</template>

<script>
import Mapa from './Mapa';
import Dados from './Dados';
import RelatorioVenRotasService from '@/services/RelatorioVenRotasService';

export default {
    components: {
        Mapa, 
        Dados
    },
    data() {
        return {
            abas: ['mapa', 'dados'],
            abaSelecionada: 0,
            service: new RelatorioVenRotasService(this.$http, this.$router),
            dataRota: new Date,
            rotas: [],
            firstTime: true, // Flag pra saber se é a primeira vez para mostrar a mensagem de ajuda ou dados não encontrados
            idPinAberto: null, // O ID é do ROTAVISITAHISTORICO
            permissao: {},
        }
    },
    created () {
        this.permissao = this.hasPermissionAccess('vendas', 'relatorio-geoanalise', 'relatorio-vendas-rotas');

        !this.permissao.read && this.$router.push({
            name: 'acesso-nao-permitido',
            params: { tela: 'routes' },
        });
    },
    methods: {
        loadData(vendedores) {
            this.$store.commit('addLoader');

            let dt = this.$moment(this.dataRota).format("YYYY-MM-DD");

            this.service.load(dt, vendedores)
            
                .then(r => {
                    this.rotas = r.content;

                    if (this.$refs.abaMapa && r.content.length > 0) {
                        this.$refs.abaMapa.centerMap();
                    }
                })
                .catch(e => {
                    this.$root.showMessage('error', 'msg-erro-relatorio');
                })
                .finally(_ => {
                    this.firstTime = false;
                    this.$store.commit('removeLoader');
                });
        }
    },
}
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px 20px 20px;
    min-height: 100%;

    .page {
        position: relative;
        padding: 20px;
        background-color: $sovis-white;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        margin-bottom: 20px;
        height: inherit;
        min-height: 100%;

        .nav.nav-tabs {
            margin-bottom: 0;
            margin-left: -20px;
            padding-left: 20px;
        }
    }
}
</style>